export const categories : string[] = ['Brooches', 'Earrings', 'Necklaces', 'Others']

export const imageUrls : {category: string, url: string}[] =[
  {category: categories[0], url: 'https://res.cloudinary.com/dqngoafsr/image/upload/v1696579072/HomeBaseGallery/rj9f1godzxxxc0l7t9ex.jpg'},
  {category: categories[1], url: 'https://res.cloudinary.com/dqngoafsr/image/upload/v1696380011/HomeBaseGallery/bydyfyaqavol9nlmdk3i.jpg'},
  {category: categories[2], url: 'https://res.cloudinary.com/dqngoafsr/image/upload/v1696380011/HomeBaseGallery/gn0rjjz4w04dg9lnqg79.jpg'},
  {category: categories[3], url: 'https://res.cloudinary.com/dqngoafsr/image/upload/v1696380011/HomeBaseGallery/ajf86vng6keujptnkizu.jpg'},

]